var map = {
  "./air-quality-index.vue": [
    "37519",
    "65460"
  ],
  "./private-land": [
    "24585",
    "2962"
  ],
  "./wildfire-smoke.vue": [
    "7472",
    "95561"
  ],
  "./active-wildfire.vue": [
    "33431",
    "5316"
  ],
  "./motorized-trails": [
    "74659",
    "51712"
  ],
  "./precip-radar.vue": [
    "32230",
    "17643"
  ],
  "./snowmobile-trails.vue": [
    "90014",
    "57619"
  ],
  "./wind-forecast": [
    "39572",
    "25067"
  ],
  "./snowmobile-trails": [
    "90014",
    "57619"
  ],
  "./private-land.vue": [
    "24585",
    "2962"
  ],
  "./precip-radar": [
    "32230",
    "17643"
  ],
  "./motorized-trails.vue": [
    "74659",
    "51712"
  ],
  "./wind-forecast.vue": [
    "39572",
    "25067"
  ],
  "./fishing-areas.vue": [
    "36230",
    "13803"
  ],
  "./active-wildfire": [
    "33431",
    "5316"
  ],
  "./air-quality-index": [
    "37519",
    "65460"
  ],
  "./wildfire-smoke": [
    "7472",
    "95561"
  ],
  "./fishing-areas": [
    "36230",
    "13803"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 61767;
module.exports = __rspack_async_context;
